import React, { FC } from 'react';
import classes from './styles/index.module.scss';
import classNames from 'classnames';
import { useStyleContextState } from '../../../../../../ReactSharedScripts/modules/styleContext';
import { ErrorBoundary } from '../../../../../../ReactSharedScripts/components/ErrorBoundary';
import { ThemeStyle } from '../../../../../../ReactSharedScripts/utils/const';

type StaticHeaderLayoutProps = {
	className?: string;
	isExperimental?: boolean;
	hasBackgroundTransparency?: boolean;
	hasKeyIndicators?: boolean;
};

export const StaticHeaderLayout: FC<React.PropsWithChildren<StaticHeaderLayoutProps>> = ({
	className,
	children,
	isExperimental,
	hasBackgroundTransparency,
	hasKeyIndicators,
}) => {
	const { theme } = useStyleContextState();
	const componentClasses = classNames(classes.staticHeader, className, {
		[classes.staticHeader_darkTheme]: theme === ThemeStyle.Dark && !isExperimental,
		[classes.staticHeader_dangerTheme]: isExperimental,
		[classes.staticHeader_hasKeyIndicators]: hasKeyIndicators,
		[classes.staticHeader_hasTransparency]: hasBackgroundTransparency,
	});

	return (
		<ErrorBoundary>
			<div
				className={componentClasses}
				data-testid='staticHeaderLayout'
				data-layout-component='detailStaticHeader'
			>
				<div className={classes.inner}>{children}</div>
			</div>
		</ErrorBoundary>
	);
};
